import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系統首頁' }, component: () => import('../views/manager/Home') },
      { path: 'password', name: 'Password', meta: { name: '修改密碼' }, component: () => import('../views/manager/Password') },
      { path: 'dailyProduct', name: 'dailyProduct', meta: { name: '單日商品銷售信息' }, component: () => import('../views/manager/DailyProduct.vue') },
      { path: 'dailyGuide', name: 'dailyGuide', meta: { name: '單日導游銷售總覽' }, component: () => import('../views/manager/DailyGuide.vue') },
      { path: 'dailyGuidePerson', name: 'dailyGuidePerson', meta: { name: '單日導游個人銷售信息' }, component: () => import('../views/manager/DailyGuidePerson.vue') },
      { path: 'dailyDetails', name: 'dailyDetails', meta: { name: '單日詳細銷售信息' }, component: () => import('../views/manager/DailyDetails.vue') },
      { path: 'termProduct', name: 'termProduct', meta: { name: '多日商品銷售信息' }, component: () => import('../views/manager/TermProduct.vue') },
      { path: 'termGuide', name: 'termGuide', meta: { name: '多日導游銷售總覽' }, component: () => import('../views/manager/TermGuide.vue') },
      { path: 'termGuidePerson', name: 'termGuidePerson', meta: { name: '多日導游個人銷售信息' }, component: () => import('../views/manager/TermGuidePerson.vue') },
      { path: 'termDetails', name: 'termDetails', meta: { name: '多日詳細銷售信息' }, component: () => import('../views/manager/TermDetails.vue') },


    ]
  },
  // {
  //   path: '/front',
  //   name: 'Front',
  //   component: () => import('../views/Front.vue'),
  //   children: [
  //     { path: 'home', name: 'Home', meta: { name: '系統首頁' }, component: () => import('../views/front/Home') },
  //
  //   ]
  // },
  { path: '/login', name: 'Login', meta: { name: '登錄' }, component: () => import('../views/Login.vue') },
  { path: '*', name: 'NotFound', meta: { name: '無法訪問' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
